module.exports = __webpack_public_path__ + "img/home-index-logo.02983070.png";